import {Component, ViewChild, ElementRef, OnInit, ViewEncapsulation, OnDestroy} from '@angular/core';
import {AppComponent} from "../../app.component";
import {contentForButton, ContentForListButtons, ModuleInfoExplanation} from "../../models/module.model";
import {NavigationEnd, Router} from "@angular/router";
import {ModalTypes} from "../../enums/modal-types";
import {ModalTemplates} from "../../enums/modal-templates";
import {ExplanationType} from "../../enums/explanation-types";
import {titles} from "../../const/texts-common-sections";
import {RouterLinks} from "../../enums/router-links";
import {AuthGuard} from "../../helpers/auth-guard.helper";
import {Subject, takeUntil} from "rxjs";


@Component({
  selector: 'app-module-explanation',
  templateUrl: './module-explanation.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./module-explanation.component.less']
})
export class ModuleExplanationComponent implements OnInit, OnDestroy {
  @ViewChild('buttonNext') buttonNext!: ElementRef;
  @ViewChild('buttonPrev') buttonPrev!: ElementRef;

  global_texts: any = null;
  module_id: number = 1;
  has_button_previous: boolean = false;
  mod_info_explanation!: ModuleInfoExplanation | null;
  current_screen_small_texts: string[] | null = null;
  current_screen_annexes: string[] | null = null;
  list_buttons!: Map<string, any[]>;
  list_buttons_keys: string[] = [];
  private unsubscribe$ = new Subject<void>();

  constructor(
    public app: AppComponent,
    private router: Router,
    private authGuard: AuthGuard
  ) {
    // Subscribe to router events
    //this.router.events.subscribe((event) => {
    this.router.events.pipe(takeUntil(this.unsubscribe$)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log("NavigationEnd event EXPL => ", event);
        this.initializeComponentExpl();
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit(): void {
    this.initializeComponentExpl();
  }

  initializeComponentExpl(): void {
    // Verify if the logout button was clicked
    if(this.authGuard.isLogoutClicked) {
      return;
    }

    // Scroll to the top of the page
    window.scrollTo(0, 0);

    // Get the global texts
    this.app.sharedHelper.getGlobalTexts().subscribe((texts: any) => {
      this.global_texts = texts;

      // Reset the data
      this.mod_info_explanation = null;
      this.list_buttons_keys = [];
      this.current_screen_small_texts = null;
      this.current_screen_annexes = null;
      // Blur the buttons
      if(this.buttonNext) this.buttonNext.nativeElement.blur();
      if(this.buttonPrev) this.buttonPrev.nativeElement.blur();

      // Small texts of the current screen
      let current_screen_small_texts = this.app.sharedHelper.getCurrentScreenParam('small_texts');
      if (current_screen_small_texts) this.current_screen_small_texts = Object.values(current_screen_small_texts);

      // Annexes of the current screen
      this.current_screen_annexes = this.app.sharedHelper.getCurrentScreenParam('annexes');

      // Get the info explanation
      this.getExplanation();
    });
  }

  getExplanation(): void {
    let current_screen = this.app.sharedHelper.getCurrentScreen() || null;
    if(!current_screen) return;

    console.log("current_screen", current_screen);
    this.has_button_previous = current_screen.has_button_previous;

    this.list_buttons = new Map<string, any[]>();

    // Get the info explanation (one or two
    this.mod_info_explanation = current_screen.explanation;
    //this.mod_info_explanation = (this.is_step_1_visible) ? mod_info?.info?.info_explanation?.explanation_one : mod_info.info.info_explanation.explanation_two;

    // Get the list of buttons if exists
    if (this.mod_info_explanation?.list_buttons) {
      this.list_buttons = this.app.sharedHelper.groupBy(this.mod_info_explanation.list_buttons, (button: ContentForListButtons) => button.group);
      this.list_buttons_keys = Array.from(this.list_buttons.keys());
    }
  }

  openModalExplanation( info_button: ContentForListButtons): void {
    this.app.dialogService.confirmThis(
      info_button.title,
      '',
      ModalTypes.Custom,
      (info_button.content[0].image) ? ModalTemplates.InfoImagesFlex : ModalTemplates.InfoOnlyText,
      () => { // Code to execute on YES
      },
      () => { // Code to execute on NO
      },
      info_button.content
    );
  }

  openModalBtnExplanation( info_button: contentForButton): void {
    this.app.dialogService.confirmThis(
      info_button.title,
      '',
      ModalTypes.Custom,
      ModalTemplates.InfoOnlyText,
      () => { // Code to execute on YES
      },
      () => { // Code to execute on NO
      },
      info_button
    );
  }

  protected readonly ExplanationType = ExplanationType;
  protected readonly titleCasComptoir1 = titles.titleCasComptoir1;
}
